import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { MedicalFeePrePaymentSearchItem } from '../../model/medical-fee/medical-fee-pre-payment-search-item';
import { MedicalFeePaymentEditInfo } from '../../model/medical-fee/medical-fee-payment-edit-info';
import { MedicalFeeWithholdTaxFilter } from '../../model/medical-fee/medical-fee-with-holdTaxFilter';
import { MedicalFeeAmount } from '../../model/medical-fee/medical-fee-amount';
import { MedicalFeePaymentSearchItem } from 'src/app/model/medical-fee/medical-fee-payment-search-item';

@Injectable({
  providedIn: 'root'
})
export class MedicalFeePaymentService {

  constructor( private dataService: DataService ) { }

  private readonly getMedicalFeePrePaymentSearchItemsEndPoint: string =
          '/medicalFeePayment/getMedicalFeePrePaymentSearchItems/';

  private readonly getMedicalFeePaymentEditInfoEndPoint: string =
          '/medicalFeePayment/getMedicalFeePaymentEditInfo/';

  private readonly  getMedicalFeeWithholdTaxFiltersEndPoint: string =
          '/medicalFeePayment/getMedicalFeeWithholdTaxFilters/';
 
  private readonly createMedicalFeeBillEndPoint: string =
          '/medicalFeePayment/createMedicalFeeBill/';

  private readonly getMedicalFeePaymentSearchItemsEndPoint: string =
          '/medicalFeePayment/getMedicalFeePaymentSearchItems/';

  private readonly cancelMedicalFeeBillEndPoint: string =
          '/medicalFeePayment/cancelMedicalFeeBill/';

  async getMedicalFeePaymentSearchItems( number?: number,
    physicianId?: number, payDateFrom?: Date, payDateTo?: Date,
    paymentDate?: Date, medicalFeePeriodId?: number ): Promise<MedicalFeePaymentSearchItem[]> {

      let toUtc = '';
      let fromUtc = '';
      let paymentDateUtc = '';

      if ( paymentDate ) {
        paymentDateUtc = new Date(paymentDate.getFullYear(),
        paymentDate.getMonth(), paymentDate.getDate()).toDateString();
      }

      if ( payDateFrom ) {
        fromUtc = new Date(payDateFrom.getFullYear(),
        payDateFrom.getMonth(), payDateFrom.getDate()).toDateString();
      }

      if ( payDateTo ) {
        toUtc = new Date(payDateTo.getFullYear(),
        payDateTo.getMonth(), payDateTo.getDate()).toDateString();
      }

    const param = {
      number,
      physicianId,
      payDateFrom: fromUtc,
      payDateTo: toUtc,
      paymentDate: paymentDateUtc,
      medicalFeePeriodId
    };

    return await this.dataService
          .get<MedicalFeePaymentSearchItem[]>(this.getMedicalFeePaymentSearchItemsEndPoint,
            param).toPromise();
  }

  async cancelMedicalFeeBill( medicalFeeBillId: number ): Promise<boolean> {

    const param = { Id: medicalFeeBillId };
    return await this.dataService.post<boolean>(this.cancelMedicalFeeBillEndPoint,
      param).toPromise();
  }

  async createMedicalFeeBill( medicalFeePaymentEditInfo: MedicalFeePaymentEditInfo ):
    Promise<boolean> {

    return await this.dataService.post<boolean>(this.createMedicalFeeBillEndPoint,
      medicalFeePaymentEditInfo).toPromise();
  }
 
  async getMedicalFeeWithholdTaxFilters(): Promise<MedicalFeeWithholdTaxFilter[]> {

    const param = { };

    return await this.dataService
          .get<MedicalFeeWithholdTaxFilter[]>(this.getMedicalFeeWithholdTaxFiltersEndPoint,
            param).toPromise();
  }

  async getMedicalFeePrePaymentSearchItems(number?: number,
    physicianId?: number): Promise<MedicalFeePrePaymentSearchItem[]> {

    const param = {
      number,
      physicianId,
    };

    return await this.dataService
          .get<MedicalFeePrePaymentSearchItem[]>(this.getMedicalFeePrePaymentSearchItemsEndPoint,
            param).toPromise();
  }

  async getMedicalFeePaymentEditInfo( medicalPreFeeBillId: number ): Promise<MedicalFeePaymentEditInfo> {

    const param = {
      medicalPreFeeBillId
    };

    return await this.dataService
          .get<MedicalFeePaymentEditInfo>(this.getMedicalFeePaymentEditInfoEndPoint,
            param).toPromise();
  }
}
